import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  registerAgreement: ['input'],
  registerAgreementRequest: null,
  registerAgreementSuccess: null,
  registerAgreementFailure: ['error'],
  clearRegisterAgreement: null
});

export { Creators, Types };
